<div class="wrap">
  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" *ngIf="!isExpired">
    <h2>Choisir un mot de passe</h2>
      <!-- <mat-form-field *ngIf="!isResetMode">
          <mat-label>{{'auth.changePassword.currentPassword.label' | translate}}</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input type="password" matInput formControlName="currentPassword">
          <mat-error>{{'auth.changePassword.currentPassword.errorMessage' | translate}}</mat-error>
      </mat-form-field> -->
      <mat-form-field>
          <mat-label>{{'auth.changePassword.newPassword.label' | translate}}</mat-label>
          <mat-icon matPrefix color="primary">lock</mat-icon>
          <input type="password" matInput formControlName="newPassword">
          <mat-error>{{'auth.changePassword.newPassword.errorMessage' | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field>
          <mat-label>{{'auth.changePassword.confirmPassword.label' | translate}}</mat-label>
          <mat-icon matPrefix color="primary">lock</mat-icon>
          <input type="password" matInput formControlName="confirmPassword" [errorStateMatcher]="confirmValidMatcher">
          <mat-error>{{'auth.changePassword.confirmPassword.errorMessage' | translate}}</mat-error>
      </mat-form-field>
      <button *ngIf="!isLoading" type="submit" mat-raised-button color="primary" [disabled]="passwordForm.invalid">
          {{'global.actions.submit' | translate}}
      </button>
      <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
  </form>

  <div *ngIf="isExpired" class="expired-message">
    <h2>{{'auth.changePassword.linkExpired.title' | translate}}</h2>
    <div class="expired-message" [innerHTML]="'auth.changePassword.linkExpired.detail' | translate"></div>
  </div>
</div>
